import React, { useState } from "react";
import { CreditCard, TrendingUp, Zap } from "lucide-react";
import { showToast } from "../../../Helper/Toast";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import { useSelector } from "react-redux";
import moment from "moment";
import { hitGetSubscriptionProfessionalApi } from "../../../Redux/Professional/GetSubscriptionProfessionalSlice";
import { hitUpdateSubscriptionProfessionalApi } from "../../../Redux/Professional/UpdateSubscriptionProfessionalSlice";
import redTick from "../../../assets/img/red tick.svg";
import cancelIcon from "../../../assets/img/cross cancel.svg";
import BiddingCost from "../../../assets/img/Bidding Costs.svg";
import EarnFreeCredit from "../../../assets/img/Earn Free Credits.svg";
import tickCard from "../../../assets/img/What You Get tick.svg";
import VerifiedClients from "../../../assets/img/Verified Clients.svg";
import Business from "../../../assets/img/Grow Your Business.svg";
import ExpertSupport from "../../../assets/img/Expert Support.svg";
import {stripeKey, monthlyPlanPriceId,yearlyPlanPriceId} from "../../../Utils/Constants";



const SubscriptionDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [upgradePlanData, setUpgradePlanData] = useState(null);

  const [isOnFreePlan, setIsOnFreePlan] = useState(false);

  const [choosePlanData, setChoosePlanData] = useState(null);

  useEffect(() => {
    dispatch(hitGetSubscriptionProfessionalApi());
  }, [dispatch]);

  const subscriptionResponseData = useSelector(
    (state) => state.getSubscriptionProfessionalReducer.data
  );

  useEffect(() => {
    if (subscriptionResponseData && subscriptionResponseData.status === true) {
      setSubscriptionData(subscriptionResponseData.data);
      if (subscriptionResponseData.data !== null) {
        if (
          subscriptionResponseData.data.subscriptionDetails.plan.interval ===
          "month"
        ) {
          setUpgradePlanData(upgradePlanDataYearly);
          setChoosePlanData([choosePlanDataArray[0]]);
        } else {
          setUpgradePlanData(upgradeToProPlanMonthly);
          setChoosePlanData([choosePlanDataArray[1]]);
        }
      } else {
        setIsOnFreePlan(true);
        setSubscriptionData({
          planName: "Free Plan",
          price: 0,
          isActive: 1,
          startDate: moment().format("MM/DD/YYYY"),
          endDate: moment().add(40, "year").format("MM/DD/YYYY"),
          subscriptionDetails: {
            plan: {
              amount: 0,
            },
          },
          tagline: "Get started with limited features, perfect for individuals",
          features: [
            "Access product in up to 25 active projects/month",
            "Limited SHARED AI model, no access to tools",
            "Basic standard exports",
            "Standard priority assistance",
            "Free forever",
          ],
        });
        setUpgradePlanData(upgradeToProPlanMonthly);
        setChoosePlanData(choosePlanDataArray);
      }
    }
  }, [subscriptionResponseData]);

  const stripePromise = loadStripe(stripeKey);

  const handleSubscriptionWhenNoPlan = async (planName) => {
    //console.log("handleSubscriptionWhenNoPlan called", planName);

    let priceId = "";
    if (planName === "Pro Plan Annual") {
      priceId = yearlyPlanPriceId;
    } else if (planName === "Pro Plan Monthly") {
      priceId = monthlyPlanPriceId;
    }

    const stripe = await stripePromise;

    const response = await axios.post(
      "http://localhost:4002/v1/professional/createStripeSessionSubscription",
      {
        // amount: selectedCredits.amount * 100, // Amount in cents
        priceId: priceId,
        // You can add more details here as needed
      },
      {
        headers: {
          Authorization: `${localStorage.getItem("professionalToken")}`,
        },
      }
    );
    if (response.data.status === true) {
      window.location.href = response.data.data.url; // Redirect to Stripe Checkout
    } else {
      showToast(response.data.data.message, "error");
    }
  };

  const handleSubscriptionCancel = (subscriptionId) => {
    if (window.confirm("Are you sure you want to cancel your subscription?")) {
      // Call the API to cancel the subscription
      dispatch(
        hitUpdateSubscriptionProfessionalApi({ subscriptionId, isCancelled: 1 })
      )
        .then((response) => {
          if (response.payload && response.payload.status === true) {
            showToast("Subscription cancelled successfully", "success");
            dispatch(hitGetSubscriptionProfessionalApi());
            // Update the state or redirect as needed
          } else {
            showToast("Failed to cancel subscription", "error");
          }
        })
        .catch((error) => {
          console.error("Error cancelling subscription:", error);
          showToast("Error cancelling subscription", "error");
        });
    }
  };

  const upgradePlanHandle = (priceId, oldSubscriptionId) => {
    dispatch(
      hitUpdateSubscriptionProfessionalApi({ priceId, oldSubscriptionId })
    )
      .then((response) => {
        if (response.payload && response.payload.status === true) {
          showToast("Subscription upgraded successfully", "success");
          dispatch(hitGetSubscriptionProfessionalApi());
          // Update the state or redirect as needed
        } else {
          showToast("Failed to upgrade subscription", "error");
        }
      })

      .catch((error) => {
        console.error("Error upgrading subscription:", error);
        showToast("Error upgrading subscription", "error");
      });
  };

  const upgradePlanDataYearly = {
    name: "Pro Plan+ Yearly",
    price: "1349",
    priceId: yearlyPlanPriceId,
  };

  const upgradeToProPlanMonthly = {
    name: "Pro Plan+ Monthly",
    price: "149",
    priceId: monthlyPlanPriceId,
  };

  const choosePlanDataArray = [
    {
      name: "Pro Plan Annual",
      price: 1389,
      features: [
        "Unlimited credits and projects",
        "Up to 5 team AI users",
        "Access to Claude Sonnet, Haiku, and Opus models",
        "Full transcription input data and analysis export",
        "Dedicated assistance (phone/chat calls & onboarding)",
      ],
    },
    {
      name: "Pro Plan",
      price: 149,
      tagline: "Get started with limited features, perfect for individuals",
      features: [
        "Unlimited credits and projects",
        "Up to 5 team AI users",
        "Access to Claude Sonnet, Haiku, and Opus models",
        "Full transcription input data and analysis export",
        "Dedicated assistance (phone/chat calls & onboarding)",
      ],
    },
  ];

  // const data = {
  //   currentPlan: {
  //     name: "Pro Plan Annual",
  //     status: "ACTIVE",
  //     price: 1389,
  //     features: [
  //       "Unlimited credits and projects",
  //       "Up to 5 team AI users",
  //       "Access to Claude Sonnet, Haiku, and Opus models",
  //       "Full transcription input data and analysis export",
  //       "Dedicated assistance (phone/chat calls & onboarding)",
  //     ],
  //   },
  //   upgrade: {
  //     name: "Pro Plan+ Yearly",
  //     price: 12,
  //     nextBilling: "January 15, 2025",
  //   },
  //   freePlan: {
  //     name: "Free Plan",
  //     price: 0,
  //     tagline: "Get started with limited features, perfect for individuals",
  //     features: [
  //       "Access product in up to 25 active projects/month",
  //       "Limited SHARED AI model, no access to tools",
  //       "Basic standard exports",
  //       "Standard priority assistance",
  //       "Free forever",
  //     ],
  //   },

  //   credits: {
  //     available: 12000,
  //     used: 5000,
  //     total: 15000,
  //   },
  //   invoices: [
  //     {
  //       id: 1,
  //       date: "Oct 15, 2024",
  //       plan: "Pro Plan Annual",
  //       amount: 1389,
  //       status: "paid",
  //     },
  //     {
  //       id: 2,
  //       date: "Sep 22, 2024",
  //       plan: "Additional Credits",
  //       amount: 200,
  //       status: "paid",
  //     },
  //     {
  //       id: 3,
  //       date: "Sep 15, 2024",
  //       plan: "Pro Plan Monthly",
  //       amount: 129,
  //       status: "paid",
  //     },
  //     {
  //       id: 4,
  //       date: "Aug 15, 2024",
  //       plan: "Pro Plan Monthly",
  //       amount: 129,
  //       status: "failed",
  //     },
  //   ],
  //   paymentInfo: {
  //     cardType: "Visa",
  //     last4: "4242",
  //     expiry: "12/25",
  //   },
  // };

  const biddingData = {
    title: "Bidding Costs",
    subtitle: "Credits required to bid on different job types",
    plans: [
      {
        name: "Standard Client",
        description: "Basic job postings",
        credits: 20,
        type: "standard",
      },
      {
        name: "Premium Client",
        description: "Ready-to-go",
        credits: 30,
        type: "premium",
      },
    ],
    note: "Premium clients pay with credits to boost their job visibility and show they're serious about getting their project done",
  };

  const creditPricing = {
    title: "Credit Pricing",
    subtitle: "Simple, transparent pricing",
    perCreditPrice: 1.0,
    packages: [
      { credits: 10, price: 10.0 },
      { credits: 25, price: 25.0 },
      { credits: 50, price: 50.0 },
      { credits: 100, price: 100.0 },
    ],
    customNote: "Custom amounts available (minimum 5 credits)",
  };

  const firstTimeRewards = [
    { task: "Verify your business", credits: "+10 credits" },
    { task: "Submit your first bid", credits: "+5 credits" },
    { task: "Post your first promotion", credits: "+10 credits" },
    { task: "Verify your license", credits: "+15 credits" },
    { task: "Import reviews", credits: "+5 credits" },
    { task: "Complete your first job", credits: "+20 credits" },
  ];

  const ongoingRewards = [
    { task: "Every 10 bids submitted", credits: "+5 credits" },
    { task: "Refer a contractor", credits: "+25 credits" },
    { task: "Complete a job", credits: "+5 credits" },
  ];

  const creditPolicies = [
    "Credits expire after 1 year from purchase",
    "Credits expire after 6 months of inactivity (no Pro subscription, logins, or bids)",
    "Pro members get bid credit protection - credits refunded if job is deleted",
    "All credits are non-refundable",
  ];

  const features = [
    {
      icon: <img src={VerifiedClients} alt="Verified Clients" />,
      title: "Verified Clients",
      description: "ID-verified homeowners. No spam, no fake leads.",
      color: "#dc2626",
    },
    {
      icon: <img src={Business} alt="Business" />,
      title: "Grow Your Business",
      description:
        "Everything you need to grow and win more jobs, right from your desk.",
      color: "#10b981",
    },
    {
      icon: <img src={ExpertSupport} alt="Expert Support" />,
      title: "Expert Support",
      description: "Get help whenever you need it from our support team.",
      color: "#dc2626",
    },
  ];

  const handleViewDetailTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="subscription-dashboards pro-app-page">
      <div className="custom_container">
        {/* Header Section */}
        <div className="dashboard-header">
          <h1>Your Active Subscription</h1>
        </div>

        {/* Active Plan Card */}
        {subscriptionData && (
          <div className="plan-cards active-plans">
            <div className="plan-headers">
              <div className="plan-title-group">
                <div className="status-icon">
                  <img src={redTick} alt="tick" />
                  {/* <img src={dollar} alt="dollar" /> */}
                </div>
                <h2 className="plan-name">{subscriptionData.planName}</h2>
                <span className="badge badge-red">
                  {subscriptionData.isActive === 1 ? "Active" : "Inactive"}
                </span>
              </div>
              {!isOnFreePlan && (
                <button
                  className="btn-link"
                  onClick={() => {
                    subscriptionData.isCancelled === 0 &&
                      handleSubscriptionCancel(subscriptionData.subscriptionId);
                  }}
                >
                  {subscriptionData.isCancelled !== 1 ? (
                    <>
                      <img
                        src={cancelIcon}
                        alt="Cancel Plan"
                        className="me-1 mb-1"
                      />{" "}
                      Cancel Plan
                    </>
                  ) : (
                    <>
                      <img
                        src={cancelIcon}
                        alt="Cancel Plan"
                        className="me-1 mb-1"
                      />{" "}
                      Cancelled
                    </>
                  )}
                </button>
              )}
            </div>

            <div className="plan-price">
              <span className="currency">$</span>
              <span className="amount">
                {subscriptionData.subscriptionDetails.plan.amount / 100}
              </span>
              <span className="cents">/year</span>
            </div>

            <ul className="feature-list">
              <p className="plan-subtitle">Your Current Benefits:</p>

              {isOnFreePlan ? (
                <>
                  {subscriptionData.features.map((feature, index) => (
                    <li key={index} className="feature-item">
                      <img src={redTick} alt="redTick" className="check-icon" />
                      {/* <img
                        src={greenTick}
                        alt="greenTick"
                        className="check-icon"
                      /> */}
                      <span>{feature}</span>
                    </li>
                  ))}
                </>
              ) : (
                <>
                  {choosePlanDataArray[0].features.map((feature, index) => (
                    <li key={index} className="feature-item">
                      <img src={redTick} alt="redTick" className="check-icon" />
                      {/* <img src={greenTick} alt="greenTick" className="check-icon" /> */}
                      <span>{feature}</span>
                    </li>
                  ))}
                </>
              )}
            </ul>

            {/* <button className="btn-outline btn-full">Manage Subscription</button> */}

            {!isOnFreePlan && (
              <div className="upgrade-section">
                <h3 className="section-title">Upgrade Your Plan</h3>
                <div className="upgrade-card">
                  <div className="upgrade-content">
                    <div className="upgrade-details">
                      <p className="upgrade-plan-name">
                        {upgradePlanData.name}
                      </p>
                      <p className="upgrade-price">
                        ${upgradePlanData.price}.00 /{" "}
                        {upgradePlanData.name === "Pro Plan+ Yearly"
                          ? "12 Months"
                          : "1 Month"}
                      </p>
                    </div>
                    <button
                      className="btn-primary btn-sm"
                      onClick={() =>
                        upgradePlanHandle(
                          upgradePlanData.priceId,
                          subscriptionData.subscriptionId
                        )
                      }
                    >
                      Upgrade
                    </button>
                  </div>
                  {!isOnFreePlan && (
                    <div className="upgrade-footer mt-4">
                      Next billing date:{" "}
                      {moment(subscriptionData.endDate).format("MM/DD/YYYY")}{" "}
                      {subscriptionData.isCancelled === 1 && "(Cancelled)"}
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}

        {/* Upgrade Section */}

        {/* Choose Plan Section */}
        {choosePlanData && (
          <div className="choose-plan-section">
            <h2 className="choose-plan-title">Choose Your Plan</h2>
            <p className="choose-plan-description">
              Choose the perfect plan to grow your renovation business and
              connect with quality clients.
            </p>

            <div className="choose-plan-cards">
              {choosePlanData.map((plan, index) => (
                <div key={index} className="plan-card plan-card-choose">
                  <div className="plan-icon plan-icon-choose">
                    <img src={redTick} alt="redTick" />
                  </div>
                  <h3 className="plan-name plan-name-choose">{plan.name}</h3>
                  <div className="plan-price plan-price-choose">
                    <span className="currency">$</span>
                    <span className="amount">{plan.price}</span>
                    <span className="cents">/month</span>
                  </div>
                  <p className="free-plan-tagline">
                    Everything you need to grow your renovation business and
                    connect with quality clients.
                  </p>
                  <ul className="free-feature-list">
                    <p className="plan-subtitle">Your Current Benefits:</p>

                    {plan.features.map((feature, index) => (
                      <li key={index} className="free-feature-item">
                        <img
                          src={redTick}
                          alt="redTick"
                          className="check-icon"
                        />
                        {/* <img src={greenTick} alt="greenTick" className="check-icon" /> */}
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="btn_choose">
                    <button
                      className="btn-primary btn_width_full"
                      onClick={() => handleSubscriptionWhenNoPlan(plan.name)}
                    >
                      Start Monthly Plan - $149/mo
                    </button>
                    <p className="free-plan-tagline">
                      No setup fee • Cancel anytime
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="pricing-containerss">
          {/* Bidding Costs Card */}
          <div className="pricing-card">
            <div className="card-header">
              <div className="card_top_1">
                <div className="header-icon bidding-icon">
                  <img src={BiddingCost} alt="Bidding Costs" />
                </div>
                <div className="header-content">
                  <h2 className="card-title">{biddingData.title}</h2>
                </div>
              </div>
              <p className="card-subtitle">{biddingData.subtitle}</p>
            </div>

            <div className="pricing-options">
              {biddingData.plans.map((plan, index) => (
                <div key={index} className={`pricing-option ${plan.type}`}>
                  <div className="option-info">
                    <h3 className="option-name">{plan.name}</h3>
                    <p className="option-description">{plan.description}</p>
                  </div>
                  <div className={`credit-badge ${plan.type}`}>
                    <span className="credit-amount">
                      {plan.credits} credits
                    </span>
                  </div>
                </div>
              ))}
            </div>

            <div className="pricing-note">
              <p>
                Premium clients pay with credits to boost their job visibility
                and show they’re serious about getting their project done.
              </p>
            </div>
          </div>

          {/* Credit Pricing Card */}
          <div className="pricing-card">
            <div className="card-header">
              <div className="card_top_1">
                <div className="header-icon credit-icon">
                  <TrendingUp size={20} />
                </div>
                <div className="header-content">
                  <h2 className="card-title">{creditPricing.title}</h2>
                </div>
              </div>
              <p className="card-subtitle">{creditPricing.subtitle}</p>
            </div>

            <div className="price-display">
              <div className="main-price">
                <span className="currency">$</span>
                <span className="amount">
                  {creditPricing.perCreditPrice.toFixed(2)}
                </span>
              </div>
              <p className="price-label">per credit</p>
            </div>

            <div className="credit-packages">
              {creditPricing.packages.map((pkg, index) => (
                <div key={index} className="package-row">
                  <span className="package-credits">{pkg.credits} credits</span>
                  <span className="package-price">${pkg.price.toFixed(2)}</span>
                </div>
              ))}
            </div>

            <div className="custom-note">
              <p>{creditPricing.customNote}</p>
            </div>
          </div>
        </div>

        {/* Buy Credits Button */}
        <div className="action-section mt-4 mt-lg-5">
          <button
            className="btn-buy-credits"
            onClick={() => {
              handleViewDetailTop();
              navigate("/professional/buy-credits");
            }}
          >
            <CreditCard size={18} />
            Buy Credits
          </button>
        </div>

        <div className="earn-credits-wrapper">
          {/* Main Card */}
          <div className="earn-credits-card">
            <div className="card-header" style={{ flexDirection: "row" }}>
              <div className="header-icon">
                <img src={EarnFreeCredit} alt="earn free credit" />
              </div>
              <div className="header-content">
                <h1 className="card-title">Earn Free Credits</h1>
                <p className="card-subtitle">
                  Complete act ions to get free credits and grow your business
                </p>
              </div>
            </div>

            <div className="rewards-grid">
              {/* First-Time Rewards */}
              <div className="rewards-section">
                <div className="section-header">
                  <Zap size={18} className="section-icon" />
                  <h2 className="section-title">First-Time Rewards</h2>
                </div>

                <div className="rewards-list">
                  {firstTimeRewards.map((reward, index) => (
                    <div key={index} className="reward-item">
                      <span className="reward-task">{reward.task}</span>
                      <span className="reward-badge">{reward.credits}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Ongoing Rewards */}
              <div className="rewards-section">
                <div className="section-header">
                  <TrendingUp size={18} className="section-icon" />
                  <h2 className="section-title">Ongoing Rewards</h2>
                </div>

                <div className="rewards-list">
                  {ongoingRewards.map((reward, index) => (
                    <div key={index} className="reward-item">
                      <span className="reward-task">{reward.task}</span>
                      <span className="reward-badge">{reward.credits}</span>
                    </div>
                  ))}
                  {/* Referral Banner */}
                  <div className="referral-banner">
                    <div className="banner-content">
                      <h3 className="banner-title">Referral Bonus</h3>
                      <p className="banner-text">
                        Both you and your referred contractor get 25 credits
                        when they sign up and verify their business. No limit on
                        referrals!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Credit Policy */}
          <div className="credit-policy">
            <h3 className="policy-title">Credit Policy</h3>
            <ul className="policy-list">
              {creditPolicies.map((policy, index) => (
                <li key={index} className="policy-item">
                  <span className="policy-bullet">
                    <img src={tickCard} alt="tick" />
                  </span>
                  <span>{policy}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Feature Cards */}
          <div className="features-section">
            {features.map((feature, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon" style={{ color: feature.color }}>
                  {feature.icon}
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>

          {/* Bottom CTA */}
          <div className="cta-section">
            <h2 className="cta-title">Questions about pricing?</h2>
            <p className="cta-subtitle">
              Our team is here to help you choose the right plan for your
              business.
            </p>
            <button className="btn-contact">Contact Sales</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionDashboard;
